__turbopack_context__.v({
  "inputError": "InputName-module-scss-module__nmCwnW__inputError",
  "inputLabel": "InputName-module-scss-module__nmCwnW__inputLabel",
  "inputName": "InputName-module-scss-module__nmCwnW__inputName",
});
